import api from '@e74/services/ApiConfig';
import {fetchError, fetchSuccess} from '../Common';
export const ACTION_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  FETCH_ALL: 'FETCH_ALL',
  FETCH_BY_ID: 'FETCH_BY_ID',
};

export const fetchAll = (pageSize, pageNumber) => (dispatch) => {
  api
    .instances()
    .fetchAll(pageSize, pageNumber)
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const create = (data, onSuccess, onError) => {
  return async (dispatch) => {
    api
      .instances()
      .create(data)
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          dispatch({
            type: ACTION_TYPES.CREATE,
            payload: res.data,
          });
          dispatch(fetchSuccess());
          onSuccess();
        } else {
          dispatch(fetchError(res.response.data.error));
          dispatch(fetchError(res));
          onError();
        }
      })
      .catch((err) => {
        onError();
        err.response !== undefined
          ? dispatch(fetchError(err.response.data.error))
          : dispatch(fetchError(err));
      });
  };
};

export const update = (id, data, onSuccess, onError) => (dispatch) => {
  api
    .instances()
    .update(id, data)
    .then((res) => {
      if (res.status >= 200 && res.status <= 300) {
        dispatch({
          type: ACTION_TYPES.UPDATE,
          payload: res.data,
        });
        dispatch(fetchSuccess());
        onSuccess();
      } else {
        onError(res.data.errors, res.data.message);
        dispatch(fetchError(res.response.data.error));
        dispatch(fetchError(res));
      }
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id, onSuccess) => (dispatch) => {
  api
    .instances()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const fetchById = (id, onSuccess) => (dispatch) => {
  api
    .instances()
    .fetchById(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.FETCH_BY_ID,
        payload: id,
      });
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
